import styled from "styled-components"

const StyledDetails = styled.details`
  border-bottom: 1px solid var(--grey-40);
  padding: 16px 0;
  display: block;
  position: relative;
  box-sizing: content-box;
`

const StyledSummary = styled.summary`
  list-style: none;
  padding: 4px 4px 4px 0;
  cursor: pointer;
  display: block;

  h3 {
    font: var(--text-md);
    font-weight: 700;
    margin: 0;
    color: var(--grey-70);
  }

  &:hover h3 {
    color: var(--blue-dark);
  }

  &:focus {
    outline: none;

    &:before {
      top: -1px;
      bottom: -1px;
      right: -16px;
      left: -16px;
      content: "";
      height: 100%;
      display: block;
      position: absolute;
      border: 1px solid var(--blue);
      border-radius: 4px;
      z-index: 0;
      pointer-events: none;
    }

    & + * {
      position: relative;
      z-index: 1;
    }
  }

  &::marker,
  &::-webkit-details-marker {
    display: none;
  }

  &::after {
    content: "";
    position: absolute;
    top: 24px;
    right: 4px;
    background: url(/g-static/icons/arrow-tip.svg);
    width: 8px;
    height: 13px;
  }

  [open] &::after {
    transform: rotate(90deg);
  }

  [open] & h3 {
    color: var(--blue-dark);
  }

  + * {
    margin-top: 16px;
  }
`

const Details = ({ summary, children }) => {
  return (
    <StyledDetails>
      <StyledSummary>{summary}</StyledSummary>
      {children}
    </StyledDetails>
  )
}

export default Details
